import Vue from "vue";
import Guid from "../../helpers/guid";
import ConditionalRule from "./conditionalRule";
import ConditionalRuleSet from "./conditionalRuleSet";
import { TargetType } from "./targetType";

export default class ConditionalRuleFactory {
  constructor() {

  }

  static create(
      conditionalRuleSet: ConditionalRuleSet,
      json: object,
      isAttached: boolean = false,
      isNew: boolean = false,
  ): ConditionalRule {
    const rule: ConditionalRule = conditionalRuleSet.createNewRule();
    rule.rootModel = conditionalRuleSet.rootModel;
    rule.parent = conditionalRuleSet;
    rule.defineProperty('client_id', json['client_id'] || Guid.create());
    rule.defineProperty('referenced_control_id', null);
    rule.defineProperty('target_type', TargetType.value);
    rule.defineProperty('comparison_type', null);
    rule.defineProperty('comparison', null);
    rule.defineProperty('value', null);
    rule.defineProperty('sort_order', conditionalRuleSet.nextRuleSortOrder(), isNew);
    rule.defineProperty('value_duration_unit', null);
    rule.defineProperty('is_reference', null);
    rule.defineProperty('referenced_value_id', null);
    rule.defineProperty('date_type', "static");
    rule.defineProperty('relative_date_type', "last");
    rule.defineProperty('relative_date', "monday");

    if (isAttached) {
      rule.repo.add(rule);
    }
    Vue.set(conditionalRuleSet.conditional_rules, rule.client_id, rule);

    return rule;
  }
}